import {IPaymentReconciliationForm} from "../models/models";

export const PAYMENT_RECONCILIATION_FORM_INITIAL_VALUE: IPaymentReconciliationForm = {
    firstPreauthAmount: '',
    secondPreauthAmount: '',
    dispositiveAmount: ''
}
